export const adaptInsumo = (insumo) => {
    return {
        id: insumo?.idInsumoN,
        label: insumo?.descripcion,
        presentacion: insumo?.presentacionGenerica + insumo?.presentacion + insumo?.idUnidadNavigation?.alias,
        idUnidad: insumo?.idUnidad
    }
}

export const adaptInsumosDetalladosArray = (
    insumos
) => {
    return structuredClone(insumos?.allInsumosRI)
        ?.map(insumo => adaptInsumo(insumo));
}